<div #indicator class="indicator">
  <div class="flex-centered icon w-100"><i class="fa" [ngClass]="'fa-' + icon"></i></div>
  <div class="flex-centered value w-100"> <span #textContainer class="overflow-ellipsis"> {{ data }} </span> </div>
</div>
